import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { PageNotFoundComponent } from './core/pages/page-not-found/page-not-found.component';
import { AuthGuard } from './core/services/auth.guard';
import { PrintDataResolver } from './core/services/print-data-resolver.service';
import { ExportComponent } from './pages/export/export.component';
import { PrintPageComponent } from './print-page/print-page.component';

const routes: Routes = [
    {
        path: ':urlId/export', component: ExportComponent,
        data: {
            matomo: {
                title: 'Calculation export',
            },
        }
    },
    {
        path: ':urlId',
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
        canMatch: [AuthGuard]
    },
    {
        path: 'print', outlet: 'print', component: PrintPageComponent, resolve: { printData: PrintDataResolver },
        data: {
            matomo: {
                title: 'Calculation print',
            },
        }
    },
    {
        path: ':urlId/print', component: PrintPageComponent, resolve: { printData: PrintDataResolver },
        data: {
            matomo: {
                title: 'Calculation print (direct)',
            },
        },
    },
    {
        path: '**', component: PageNotFoundComponent
    }

];

@NgModule({
    imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
